<template>
  <div class="owner-description_block">
      <div class="left">
        <h3 class="large_black_label">事務所単位で登録が可能です。</h3>
        <p>設計事務所の従業員の方も、事務所の決済情報で受発注することができます。</p>
        <UserRegistrationButtonBox/>
      </div>
      <div class="right">
        <img class='base_image' src='@/assets/image/pages/top/owner.png'>
      </div>
  </div>
</template>

<script>
  import UserRegistrationButtonBox from "@/components/molecules/box/button/UserRegistrationButtonBox";

  export default {
    name: "OwnerDescriptionBlock",
    components: {UserRegistrationButtonBox}
  }
</script>

<style lang="scss" scoped>
  .owner-description_block {
    @include double_columns(30%, 40%);

    .user-registration-button_box {
      margin-top: 6rem;
    }

    @media screen and (max-width: 767px) {
      .user-registration-button_box {
        margin: 3rem 0;
      }
    }
  }
</style>